import React, { useEffect, useState } from "react";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import api from "../../services/api";
import Form from "../../components/form";
import MUIDataTable from "mui-datatables";

export default function Participacao({ history, location }) {
  const [registros, setRegistros] = useState([]);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [tabela, setTabela] = useState(false);
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        profissionalNome: "",
        escolaId: "",
        dataInicial: "",
        dataFinal: "",
      },
      location
    )
  );

  useEffect(() => {
    carregarComboEscolas();

    if (dadosFiltros.dataInicial && dadosFiltros.dataFinal) {
      carregarRelatorio();
    }
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);

    api.get("relatorios/participacao", filtrosEnviar).then((res) => {
      const dadosRegistros = res;

      // const dataAtual = new Date();

      dadosRegistros.forEach((r) => {
        //r.status = this.definirSituacaoRegistro(r, dataAtual);

        r.previsaoInicio = r.previsaoInicio
          ? formatDateTime(r.previsaoInicio, "D/M/Y")
          : "-";
        r.inicio = r.inicio ? formatDateTime(r.inicio, "D/M/Y h:m:s") : "-";
        r.termino = r.termino ? formatDateTime(r.termino, "D/M/Y h:m:s") : "-";
      });
      setTabela(true);
      setRegistros(dadosRegistros);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      profissionalNome: {
        label: "Profissional",
        type: "text",
        space: 6,
        value: dadosFiltros.profissionalNome,
      },
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: dadosFiltros.escolaId,
      },
      dataInicial: {
        label: "Previsão de início a partir de",
        type: "date",
        space: 6,
        value: dadosFiltros.dataInicial,
      },
      dataFinal: {
        label: "Previsão de início até",
        type: "date",
        space: 6,
        value: dadosFiltros.dataFinal,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  return (
    <div>
      <Form formData={filtros} />
      <br />
      {tabela && (
        <MUIDataTable
          title={"Participação dos profissionais"}
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
}

const columns = [
  {
    name: "escolaNome",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "carteiraNome",
    label: "Carteira",
    options: {
      filter: true,
      sort: true,
      display: "false",
    },
  },
  {
    name: "usuarioNome",
    label: "Nome",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "usuarioEmail",
    label: "Email",
    options: {
      filter: false,
      sort: false,
      display: "false",
    },
  },
  {
    name: "usuarioTelefone",
    label: "Telefone",
    options: {
      filter: false,
      sort: false,
      display: "false",
    },
  },
  {
    name: "funcaoNome",
    label: "Função",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: "cicloNome",
    label: "Ciclo",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: "unidadeTitulo",
    label: "Unidade",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: "previsaoInicio",
    label: "Previsão de início",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "inicio",
    label: "Início",
    options: {
      filter: false,
      sort: true,
      display: "false",
    },
  },
  {
    name: "termino",
    label: "Termino",
    options: {
      filter: false,
      sort: true,
      display: "false",
    },
  },
  {
    name: "situacao",
    label: "Situação",
    options: {
      filter: true,
      sort: false,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "participacao.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
  onDownload: (buildHead, buildBody, columns, data) => {
    return "\uFEFF" + buildHead(columns) + buildBody(data);
  },
};
